import { createGlobalAccountsApiClient } from '../client';
import { type GlobalAccountsApiErrorResponse } from '../types';

import { MY_ORGANIZATION_ID } from './constants';
import { type GetOrganizationResponse } from './types';

const client = createGlobalAccountsApiClient();

/**
 * Global Accounts API organizations client.
 * @see {@link https://platform.text.com/docs/authorization/global-accounts-api#tag/Organizations}
 */
export const organizationsClient = {
  /**
   * Retrieves the details of an organization. Defaults to the caller's own organization.
   * @param organizationId - The organization id, or `my` for the token's own organization.
   * @see {@link https://platform.text.com/docs/authorization/global-accounts-api#tag/Organizations/paths/~1organizations~1%7Borganization_id%7D/get}
   */
  get: async (organizationId: string = MY_ORGANIZATION_ID) => {
    return client.get<GetOrganizationResponse, GlobalAccountsApiErrorResponse>(`organizations/${organizationId}`);
  },
};
